var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterBg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 444,
    viewBox: "0 0 1440 444",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 61,
    width: 1440,
    height: 1,
    fill: "white",
    fillOpacity: 0.05
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 141,
    width: 1440,
    height: 1,
    fill: "white",
    fillOpacity: 0.05
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 221,
    width: 1440,
    height: 1,
    fill: "white",
    fillOpacity: 0.05
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 301,
    width: 1440,
    height: 1,
    fill: "white",
    fillOpacity: 0.05
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    y: 381,
    width: 1440,
    height: 1,
    fill: "white",
    fillOpacity: 0.05
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    y: -498,
    width: 1,
    height: 1440,
    fill: "white",
    fillOpacity: 0.05
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: -498,
    width: 1,
    height: 1440,
    fill: "white",
    fillOpacity: 0.05
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: -498,
    width: 1,
    height: 1440,
    fill: "white",
    fillOpacity: 0.05
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: -498,
    width: 1,
    height: 1440,
    fill: "white",
    fillOpacity: 0.05
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: -498,
    width: 1,
    height: 1440,
    fill: "white",
    fillOpacity: 0.05
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: -498,
    width: 1,
    height: 1440,
    fill: "white",
    fillOpacity: 0.05
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: -498,
    width: 1,
    height: 1440,
    fill: "white",
    fillOpacity: 0.05
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 560,
    y: -498,
    width: 1,
    height: 1440,
    fill: "white",
    fillOpacity: 0.05
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 640,
    y: -498,
    width: 1,
    height: 1440,
    fill: "white",
    fillOpacity: 0.05
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: -498,
    width: 1,
    height: 1440,
    fill: "white",
    fillOpacity: 0.05
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 800,
    y: -498,
    width: 1,
    height: 1440,
    fill: "white",
    fillOpacity: 0.05
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 880,
    y: -498,
    width: 1,
    height: 1440,
    fill: "white",
    fillOpacity: 0.05
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 960,
    y: -498,
    width: 1,
    height: 1440,
    fill: "white",
    fillOpacity: 0.05
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 1040,
    y: -498,
    width: 1,
    height: 1440,
    fill: "white",
    fillOpacity: 0.05
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 1120,
    y: -498,
    width: 1,
    height: 1440,
    fill: "white",
    fillOpacity: 0.05
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 1200,
    y: -498,
    width: 1,
    height: 1440,
    fill: "white",
    fillOpacity: 0.05
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 1280,
    y: -498,
    width: 1,
    height: 1440,
    fill: "white",
    fillOpacity: 0.05
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 1360,
    y: -498,
    width: 1,
    height: 1440,
    fill: "white",
    fillOpacity: 0.05
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 444,
    fill: "url(#paint0_radial_131_282)"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 297,
    width: 1,
    height: 9,
    fill: "#FC5719"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 301,
    width: 9,
    height: 1,
    fill: "#FC5719"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 57,
    width: 1,
    height: 9,
    fill: "#FC5719"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 396,
    y: 61,
    width: 9,
    height: 1,
    fill: "#FC5719"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 1200,
    y: 217,
    width: 1,
    height: 9,
    fill: "#FC5719"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 1196,
    y: 221,
    width: 9,
    height: 1,
    fill: "#FC5719"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 1280,
    y: 377,
    width: 1,
    height: 9,
    fill: "#FC5719"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 1276,
    y: 381,
    width: 9,
    height: 1,
    fill: "#FC5719"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_131_282",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(720 222) scale(720 222)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272727",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272727",
    stopOpacity: 0.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterBg1);
export default __webpack_public_path__ + "static/media/footer-bg1.c270c0abb86d1ea5af98c27296edae7e.svg";
export { ForwardRef as ReactComponent };